module.exports = __webpack_public_path__ + "static/media/ehealth_pro_mini_assistant_p1_2.d291cd65.png";